import { InputBase, Box, InputAdornment, Divider } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import { SearchBarProps } from '../../interfaces/interfaces';
import { useTranslation } from 'react-i18next';
import { appStyleMode } from '../../helpers/clientConfigs';
import { AppStyle } from '../../helpers/appStyle';

export function SearchBar({ setSearch, searchValue }: SearchBarProps) {
  const { t } = useTranslation();

  return (
    <Box sx={{ height: '56px', mt: appStyleMode !== AppStyle.Mobile && '15px', mb: '15px' }}>
      <InputBase
        fullWidth
        autoFocus
        sx={{
          color: 'black',
          backgroundColor: 'white',
          px: '10px',
          borderRadius: '4px',
          py: '5px',
        }}
        placeholder={t('services:search')}
        value={searchValue}
        onChange={(e) => setSearch(e.target.value)}
        startAdornment={
          <InputAdornment position="start">
            <SearchIcon />
          </InputAdornment>
        }
        endAdornment={
          <InputAdornment position="end">
            <ClearIcon
              sx={{ visibility: searchValue ? 'visible' : 'hidden', cursor: 'pointer' }}
              onClick={() => setSearch('')}
            />
          </InputAdornment>
        }
      />
      <Divider sx={{ width: '100%', mt: '10px' }} />
    </Box>
  );
}
